import { Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { getVersionLabel } from "@/utils/appVersion.util";
import { joinTestIDs } from "@/utils/string.util";

const AppVersionLabel = ({ testID }: ViewWithTestID) => {
  const currentYear = new Date().getFullYear();
  const copyrightLabel = `© ${currentYear} Equip Health, Inc.`;
  return (
    <HStack alignItems="center" gap={24} justifyContent="center" padding={8}>
      <Text testID={joinTestIDs(testID, "version")} variant="caption">
        {getVersionLabel()}
      </Text>
      <Text testID={joinTestIDs(testID, "copyright")} variant="caption">
        {copyrightLabel}
      </Text>
    </HStack>
  );
};

export default AppVersionLabel;
